"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _EotcBuySellOrderOverviewComponent = _interopRequireDefault(require("./EotcBuySellOrderOverviewComponent"));
var _instrumentPositionSelectors = require("../../../../redux/selectors/instrumentPositionSelectors");
var _productPositionSelectors = require("../../../../redux/selectors/productPositionSelectors.js");
var _buySellSelectors = require("../../../../redux/selectors/buySellSelectors");
var _numberFormatter = require("../../../../helpers/numberFormatter");
var _orderHelper = require("../../../../helpers/orderHelper.js");
var _config = _interopRequireDefault(require("../../../../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var decimalPlaces = state.apexCore.product.decimalPlaces;
  var buySellForm = state.form.buySell || {
    values: {
      fee: {}
    }
  };
  var selectedValue = (0, _buySellSelectors.getOrderFormInfoSelector)(state);
  var isBuySide = (0, _buySellSelectors.isBuySideBuySellFormSelector)(state);
  var _selectedInstrumentSe = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state),
    Product1Symbol = _selectedInstrumentSe.Product1Symbol,
    Product2Symbol = _selectedInstrumentSe.Product2Symbol;
  var tradingDisabled = (0, _buySellSelectors.tradingDisabledSelector)(state);
  var quantity = selectedValue.quantity ? selectedValue.quantity : 0;
  var transactionCost = selectedValue.price ? selectedValue.price : 0;
  var pricePerUnit = selectedValue.pricePerUnit ? selectedValue.pricePerUnit : 0;
  var products = (0, _productPositionSelectors.productsSelector)(state);
  return {
    symbol1: Product1Symbol,
    symbol2: Product2Symbol,
    isBuySide: isBuySide,
    fee: (0, _orderHelper.getOrderFee)(buySellForm.values, products, 'end'),
    notEnoughMarket: tradingDisabled,
    transactionCost: (0, _numberFormatter.formatNumberToLocale)(transactionCost, Product2Symbol),
    quantity: (0, _numberFormatter.formatNumberToLocale)(quantity.toString(), Product1Symbol),
    pricePerUnit: (0, _orderHelper.getOrderPricePerUnit)(pricePerUnit, Product1Symbol, Product2Symbol, decimalPlaces),
    hideFees: !!_config["default"].global.hideFees
  };
};
var EotcBuySellOrderOverviewContainer = (0, _reactRedux.connect)(mapStateToProps)(_EotcBuySellOrderOverviewComponent["default"]);
var _default = exports["default"] = EotcBuySellOrderOverviewContainer;